import { RepostType } from "../const/RepostType"

export const generateRepostObject = (projectId: string, repostType: RepostType) => {
    return {
        projectId,
        addMethod: repostType,
        dateTime: new Date(),
    }
}import { RepostType } from "../const/RepostType"

export const generateRepostObject = (projectId: string, repostType: RepostType) => {
    return {
        projectId,
        addMethod: repostType,
        dateTime: new Date(),
    }
}